export default __webpack_public_path__ + "static/media/chat-view.6fdf8abd.png";